import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { LayoutGrid, ShoppingBag, Sparkles } from "lucide-react";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { CollectionList } from "@/components/CollectionList";
import { SHOP } from "@/data/catalog";
import { EASE, scrollToId } from "@/lib/scroll";

export const StickyBar = () => {
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <AnimatePresence>
        {show && (
          <motion.div
            data-testid="sticky-mobile-shop-bar"
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            transition={{ duration: 0.6, ease: EASE }}
            className="fixed inset-x-3 bottom-3 z-40 flex items-center gap-2 rounded-full border border-gold/30 bg-ink/85 p-1.5 backdrop-blur-xl md:hidden"
          >
            <button data-testid="sticky-bar-collections" onClick={() => setOpen(true)} className="flex flex-1 items-center justify-center gap-2 rounded-full bg-champagne py-3 text-sm font-medium text-ink">
              <LayoutGrid className="h-4 w-4" /> Collections
            </button>
            <button data-testid="sticky-bar-bestsellers" onClick={() => scrollToId("bestsellers")} className="flex flex-1 items-center justify-center gap-2 rounded-full py-3 text-sm text-cream">
              <Sparkles className="h-4 w-4 text-champagne" /> Best sellers
            </button>
            <a href={`${SHOP}/cart`} data-testid="sticky-bar-cart" aria-label="Your bag" className="grid h-11 w-11 place-items-center rounded-full border border-white/15 text-cream">
              <ShoppingBag className="h-4 w-4" />
            </a>
          </motion.div>
        )}
      </AnimatePresence>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="max-h-[82vh] overflow-y-auto rounded-t-3xl border-gold/20 bg-ink text-cream" data-lenis-prevent>
          <SheetTitle className="font-mono text-xs uppercase tracking-[0.3em] text-champagne">Shop the collections</SheetTitle>
          <CollectionList testPrefix="sticky-sheet-collection" />
        </SheetContent>
      </Sheet>
    </>
  );
};
